export default function (id) {
    if (localStorage) {
        const data = JSON.parse(localStorage.getItem('compare')) || [];
        const position = data.findIndex(item => item.id === id);
        data.splice(position, 1);
        localStorage.setItem('compare', JSON.stringify(data));
    }
}
